"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ILocationType = void 0;
var ILocationType;
(function (ILocationType) {
    ILocationType["Forest"] = "Forest";
    ILocationType["Beach"] = "Beach";
    ILocationType["Mountains"] = "Mountains";
    ILocationType["Desert"] = "Desert";
    ILocationType["City"] = "City";
    ILocationType["Savannahs"] = "Savannahs";
    ILocationType["Landmarks"] = "Landmarks";
    ILocationType["Studio"] = "Studio";
    ILocationType["Waterfront"] = "Waterfront";
})(ILocationType || (exports.ILocationType = ILocationType = {}));
//# sourceMappingURL=location-type.js.map